import { IMRBaseComponent } from "../../base"

import { USER_SESSION_SERVICE_NAME } from "../../../../services/user-session"

import { IMREditGridController } from "./edit-grid.controller"

//#region Assets Imports

import './edit-grid.scss'
import * as TEMPLATE from './edit-grid.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrEditGrid'

export class IMREditGridComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: IMREditGridController,
            services: [USER_SESSION_SERVICE_NAME],
            template: TEMPLATE
        })
    }
}
